module.exports = __webpack_public_path__ + "img/qy (5).9a2eb74f.jpg";